import { call, put, takeLatest } from 'redux-saga/effects';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { saveOCClaim } from '@/views/screens/Claims/data-provider/save-over-charge-claim';

import { getErrorMessageFromAPI } from '../../../utilz';
import { setAppLoader } from '../../common/CommonActions';
import { getOverChargeItemsFromExcelInError, getOverChargeItemsFromExcelInSuccess } from './OverChargeActions';
import { getOverChargeItemsFromExcelEffect } from './OverChargeEffects';
import { OverChargeClaimsTypes } from './OverChargeTypes';

function* updateClaimDetailsWatcher({ payload: { handleSuccess, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    yield call(saveOCClaim, payload);

    if (handleSuccess) {
      handleSuccess();
    }
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: 'Claims details updated successfully.',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch {
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: 'Claims details failed to update.',
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getItemsFromExcelWatcher({ payload: { handleSuccess, ...payload } }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(getOverChargeItemsFromExcelEffect, payload);
    yield put(getOverChargeItemsFromExcelInSuccess({ data }));
    yield put(setAppLoader(false));
    if (handleSuccess) {
      handleSuccess();
    }
  } catch (e) {
    yield put(setAppLoader(false));
    if (e?.code !== 'ERR_CANCELED') {
      yield put(
        getOverChargeItemsFromExcelInError({
          message: getErrorMessageFromAPI(e, 'Failed to get items from excel sheet'),
        }),
      );
    }
  }
}

export default function* OverChargeClaimsSaga() {
  yield takeLatest(OverChargeClaimsTypes.UPDATE_OVERCHARGE_CLAIM_PROGRESS, updateClaimDetailsWatcher);
  yield takeLatest(OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_PROGRESS, getItemsFromExcelWatcher);
}
